<span *ngIf="toggleContent">
<app-icon-container></app-icon-container>
<app-payments *ngIf="!doNotShow"></app-payments>
<app-cookies></app-cookies>
<div class="footer-row">
    <div class="footer-container">
        <div class="mw">
            <h4>{{ 'static.footerHeader' | translate }}</h4>
            <div class="row">
                <div class="footer-links-block fl xl-3 md-3 sm-3 xs-6">
                    <a [routerLink]="[showLang, 'contact-us']">{{ 'menu.contactJinniLotto' | translate }}</a>
                    <a [routerLink]="[showLang, 'privacy-policy']">{{ 'menu.privacyNotice' | translate }}</a>
                    <a [routerLink]="[showLang, 'safety-security']">{{ 'menu.safetyAndSecurity' | translate }}</a>
                    <a [routerLink]="[showLang, 'terms-conditions']">{{ 'menu.termsConditions' | translate }}</a>
                    <a [routerLink]="[showLang, 'responsible-gaming-policy']" class="mobile-show">{{ 'menu.responsibleGamingPolicy' | translate }}</a>
                    <!--<a routerLink="/bonus-terms" class="mobile-show">{{ 'menu.bonusTerms' | translate }}</a>-->
                </div>
                <div class="footer-links-block fl xl-3 md-3 sm-3 xs-6">
                    <a [routerLink]="[showLang, 'responsible-gaming-policy']" class="mobile-hide">{{ 'menu.responsibleGamingPolicy' | translate }}</a>
                    <!--<a routerLink="/bonus-terms" class="mobile-hide">{{ 'menu.bonusTerms' | translate }}</a>-->
                    <a [routerLink]="[showLang, 'game-rules']">{{ 'menu.gameRules' | translate }}</a>
                    <a [routerLink]="[showLang, 'bonus-policy']">{{ 'menu.bonuspolicy' | translate }}</a>
                    <a [routerLink]="[showLang, 'faq']">{{ 'menu.faq' | translate }}</a>
                    <a [routerLink]="[showLang, 'about-us']" class="mobile-show">{{ 'menu.aboutUs' | translate }}</a>
                    <a [routerLink]="[showLang, 'lotteries-results']" class="mobile-show">{{ 'menu.results' | translate }}</a>
                    <a href="http://affs.troll-tech.com/" *ngIf="brand === 'qiwi'" class="mobile-show">{{ 'menu.affiliateProgram' | translate }}</a>
                </div>
                <div class="footer-links-block fl xl-3 md-3 sm-3 xs-4 mobile-hide">
                    <a [routerLink]="[showLang, 'about-us']" class="mobile-hide">{{ 'menu.aboutUs' | translate }}</a>
                    <a [routerLink]="[showLang, 'lotteries-results']" class="mobile-hide">{{ 'menu.results' | translate }}</a>
                    <a href="http://affs.troll-tech.com/" *ngIf="brand === 'qiwi'" class="mobile-hide">{{ 'menu.affiliateProgram' | translate }}</a>
                </div>
                <div class="fl xl-3 md-3 sm-3 xs-3 logo-footer mobile-hide">
                    <img src="../../../assets/images/footer/trolltech-logo-web.png" *ngIf="brand === 'qiwi'">
                    <img src="../../../assets/images/logo/winaija-logo-dark.png" *ngIf="brand === 'winaija'">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="mw xl-12 md-12 sm-12 xs-12">
                <hr/>
                <div class="logo-footer mobile-show text-center">
                    <img src="../../../assets/images/footer/trolltech-logo-web.png" *ngIf="brand === 'qiwi'">
                    <img src="../../../assets/images/logo/winaija-logo-dark.png" *ngIf="brand === 'winaija'">
                </div>
                <div class="footer-text">
                    {{ 'static.footer' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
    <div *ngIf="showSuccessPaymentMethod" id="paymentAddedWithSuccess"><img class="check-it" src="../../../assets/images/icons/icon/check.svg"> {{'successPaymentMethodAdd.success' | translate}}</div>
</span>
